 
import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
 
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
 
import { stateData } from "@/constants/electionConfig";
import OldElectionScreen from "@/screens/OldStateElection";
 

export default function ElectionTab({
  latestStoryData = null,
  latestVideoData = null,
  categoryNewsListData = null,
  electionCategory = null,

  candidateProfileData = null,
  candidateList = null,
  constituencyName = null,

}) {
  const isMobileDevice = useIsMobile();
  let metaData = {
    title: `${candidateProfileData?.candidate} Delhi Assembly Election Results 2025, ${candidateProfileData?.candidate_h} Constituency Seat - NewsTak.in`,
    description: `${candidateProfileData?.candidate} Delhi Assembly Election Results 2025: Latest Updates On ${candidateProfileData?.candidate_h} Constituency Seat ${candidateProfileData?.candidate},  ${candidateProfileData?.party_h} Election Result दिल्ली विधानसभा चुनाव 2025 : उम्‍मीदवार के नाम,  चुनाव की खबरें, Constituency Seat – NewsTak.in`,
    keywords: `${candidateProfileData?.candidate} Delhi Assembly Election,  ${constituencyName} Delhi Election News,  ${constituencyName} News,  ${constituencyName} LIVE Delhi Assembly Election Results,  ${candidateProfileData?.candidate} Results, ${constituencyName} Election Results, ${constituencyName}, दिल्ली विधानसभा निर्वाचन क्षेत्र का नाम, ${constituencyName} निर्वाचन क्षेत्र 2025, ${candidateProfileData?.party_h}, प्रत्याशी का नाम,`,
  };

  const state_data = stateData[electionCategory];
  // console.log("delhi_data", electionCategory);



  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <OldElectionScreen
          // electionPath="delhi-assembly/candidates"
          electionPath={`${electionCategory}/candidates`}
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          masterKey={state_data?.masterConfigKey} //"delhi_election"
          electionPassedCategory={
            state_data?.["candidates"]?.electionPassedCategory
          } //'delhi-assembly'
          stateName={state_data?.["candidates"]?.state} //"Delhi"
          stateHindi={state_data?.["candidates"]?.stateHindi} //"महाराष्ट्र"
          metaData={metaData}
          candidateProfileData={candidateProfileData}
          candidateList={candidateList}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";

  if (!electionCategory) {
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");
 
  if(!stateData[electionCategory]){
    // console.log("stateData", stateData);
    return {
      notFound: true,
    };
  }
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;
    url = url.split("?")[0];

    // let [candidateName] = url
    //   ?.split("/")
    //   ?.pop()
    //   ?.split("-result-")
    //   ?.map((part) =>
    //     part
    //       ?.split("-")
    //       ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    //       ?.join(" ")
    //   );

    const [candidateName, constituencyID, candidateID] = url
      .split("/")
      .pop()
      .split("-result-")
      .map(
        (p, i) =>
          i === 0
            ? p
                .split("-")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" ")
            : p.split("-").slice(-2) // Get last two parts for constituency & candidate ID
      )
      .flat(); // Flatten the array to get separate variables

    // console.log(candidateName);  // "Gaurav Sharma"
    // console.log(constituencyID); // "30066"
    // console.log(candidateID);
    // api
    // const constituencyId = url.split("-").pop();
    // "id": "1833",
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    let masterConfigData = await getMasterConfig();
    let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.delhi_election;

 
    

    let constId = constituencyID; // url?.split("-").pop();
    let constituencyName = null;
    let candidateProfileData = null;
    let candidateList = null;
    let candidateUrl = electionConfigData?.isElectionAlpha
    ? // ? `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-alpha/${id}.json`
      `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-liveblog/${constId}.json`
    : `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-tak/${constId}.json`;

    // let candidateUrl = `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-tak/${constId}.json`;
    await fetch(candidateUrl,{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then(async (data) => {
      const tempCand = await data.json();
      constituencyName = tempCand?.data?.constituency_name;
      candidateList = tempCand?.data;
       
    
      candidateProfileData = tempCand?.data.candidate?.find((c) => {   
        // const isDuplicateID = duplicateIDs.includes(candidateID);
        return c?.id?.toString() == candidateID?.toString()
        //  && c?.candidate?.toLowerCase() == candidateName?.toLowerCase()
        // return isDuplicateID
        //   ? c?.id?.toString() === candidateID?.toString() && c?.candidate?.toLowerCase() === candidateName?.toLowerCase()
        //   : c?.candidate?.toLowerCase() === candidateName?.toLowerCase();
      }) || null;
    });
    
    // console.log("first", candidateProfileData);

    const { getLatestContentFeed } = await import("@/handlers/content");

   
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

     

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;
    // console.log("url3",ctx?.resolvedUrl?.split("/candidates")[0])
    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: ctx?.resolvedUrl?.split("/candidates")[0], //url
        page: page,
        display: 12,
        type: "all",
      },
    });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,

      //  faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: ctx?.resolvedUrl?.split("/candidates")[0], // url,
          page: page,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        candidateProfileData,
        candidateList,
        electionCategory,
        // faqData,
        candidateName,
        constituencyName,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
